export const callbacks: (() => void)[] = [];

/**
 * Register a callback after successful Add File form submission
 * Returns an unregister method to be called onUnmounted
 */
export const registerAddFileSubmittedAction = (cb: () => void) => {
    callbacks.push(cb);
    return () => unregisterAddFileSubmittedAction(cb);
};

export const runAddFileSubmitCallbacks = () => {
    callbacks.forEach(cb => cb());
};

const unregisterAddFileSubmittedAction = (cb: () => void) => {
    const i = callbacks.indexOf(cb);
    if (i !== -1) {
        callbacks.splice(i, 1);
    }
};
